import { ModalContentWrapper } from "components/ModalContentWrapper";
import { TextInput } from "components/TextInput";
import { FC } from "react";
import { FieldErrors, UseFormRegister } from "react-hook-form";

interface NaturvardsverketKeyFormData {
  nvKey: string;
  nvSecret: string;
}

interface Props {
  register: UseFormRegister<NaturvardsverketKeyFormData>;
  errors: FieldErrors<NaturvardsverketKeyFormData>;
}

export const NaturvardsverketKeyModal: FC<Props> = ({ register, errors }) => {
  return (
    <ModalContentWrapper>
      <div className="mb-8 space-y-8">
        <TextInput
          label="Key"
          name="nvKey"
          register={register}
          errorMessage={errors?.nvKey?.message}
        />
        <TextInput
          label="Secret"
          name="nvSecret"
          register={register}
          errorMessage={errors?.nvSecret?.message}
        />
      </div>
    </ModalContentWrapper>
  );
};

export type { NaturvardsverketKeyFormData };
